export enum PTooltipAnchor {
  TOP_START = 'top start',
  TOP_MIDDLE = 'top middle',
  TOP_END = 'top end',
  CENTER_START = 'center start',
  CENTER_MIDDLE = 'center middle',
  CENTER_END = 'center end',
  BOTTOM_START = 'bottom start',
  BOTTOM_MIDDLE = 'bottom middle',
  BOTTOM_END = 'bottom end',
}

export enum PTooltipArrow {
  START = 'start',
  TOP = 'top',
  END = 'end',
  BOTTOM = 'bottom',
}
